import React, { useEffect, ReactElement } from 'react';

import ReactModal from 'react-modal';

interface IModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onCloseModal?: () => void;
  size?: string;
}

function Modal({
  children,
  isOpen,
  setIsOpen,
  onCloseModal,
  size,
}: IModalProps): ReactElement {
  useEffect(() => {
    // Set focus to the modal content when it opens
    const modalContent = document.getElementById('modal-content');
    if (modalContent) {
      modalContent.focus();
    }
  }, [isOpen]);

  // Function to trap focus within the modal
  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key !== 'Tab') return;

    // Get the modal content
    const modalContent = event.currentTarget;

    const focusableElements = modalContent.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!event.shiftKey && document.activeElement === lastElement) {
      // Move focus to the first element if TAB is pressed on the last element
      event.preventDefault();
      firstElement.focus();
    } else if (event.shiftKey && document.activeElement === firstElement) {
      // Move focus to the last element if SHIFT + TAB is pressed on the first element
      event.preventDefault();
      lastElement.focus();
    }
  }

  return (
    <ReactModal
      id="bsa-modal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      onRequestClose={() => {
        setIsOpen(false);
      }}
      onAfterClose={onCloseModal}
      ariaHideApp={false}
      style={{
        content: {
          position: 'relative',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: '50%',
          marginRight: '-50%',
          marginTop: '20px',
          transform: 'translate(-50%, -50%)',
          background: '#fff',
          color: '#171412',
          border: '2px solid #00a859',
          borderRadius: '4px',
          width: size ? size : '640px',
          zIndex: 999,
        },
        overlay: {
          background: 'inherit',
          position: 'fixed',
          boxShadow: 'inset 3000px 3000px 3000px 3000px rgba(255,255,255,0.8)',
        },
      }}
    >
      <div
        id="modal-content"
        tabIndex={-1}
        onKeyDown={handleKeyDown}
        style={{ outline: 'none' }}
      >
        {children}
      </div>
    </ReactModal>
  );
}

export default Modal;
